import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { LegalPage, P, UL } from "@/components/marketing/LegalPage";

export const Route = createFileRoute("/legal/affiliate-vietnam")({
  head: () => ({
    meta: [
      { title: "Chương trình Đối tác Affiliate Banana (Việt Nam) — banana.cards" },
      { name: "description", content: "Điều khoản & Điều kiện Chương trình Đối tác Tiếp thị Banana Cards dành cho đối tác tại Việt Nam." },
      { property: "og:title", content: "Chương trình Đối tác Affiliate Banana (Việt Nam) — banana.cards" },
      { property: "og:description", content: "Cơ cấu hoa hồng, ghi nhận nguồn, thanh toán và quy định thương hiệu cho đối tác tiếp thị Banana Cards tại Việt Nam." },
    ],
    links: alternateLinkList("/legal/affiliate-vietnam", "en"),
  }),
  component: AffiliateVietnamPage,
});

export function AffiliateVietnamPage() {
  return (
    <LegalPage
      eyebrow="Pháp lý · Đối tác"
      title="Chương trình"
      italic="Đối tác Affiliate."
      updated="Tháng 1, 2026"
      intro="Biến mạng lưới quan hệ thành nguồn thu nhập thụ động. Chia sẻ Banana Cards trực tuyến, nhận hoa hồng trên mọi đơn hàng và gói phần mềm đăng ký. Không cần nhập hàng, không chi phí đầu tư, không lo vận hành. Mọi thứ được theo dõi tự động và thanh toán nhanh chóng qua bảng quản trị đối tác."
      related={[
        { label: "Affiliate Program — Global", to: "/legal/affiliate-global" },
        { label: "Hợp đồng Đại lý — Việt Nam", to: "/legal/retailer-vietnam" },
        { label: "Điều khoản dịch vụ", to: "/terms" },
      ]}
      sections={[
        {
          id: "tomtat",
          title: "Tóm tắt chương trình",
          body: (
            <>
              <P><strong>Không tồn kho. Không rủi ro.</strong> Đối tác không cần giữ kho, không cần mua hàng, lưu kho hay vận chuyển — chỉ quảng bá bằng link đối tác hoặc mã QR.</P>
              <P><strong>Chính sách hoa hồng đơn giản:</strong> 25% trên doanh số phần cứng và 25% trọn đời trên các gói đăng ký phần mềm, tính trên giá chưa gồm VAT và theo dõi tự động.</P>
              <P><strong>Thu nhập thụ động (không hết hạn):</strong> Hoa hồng phần mềm được trả vĩnh viễn khi khách còn duy trì gói. Không áp trần, không giới hạn 12 tháng, không reset.</P>
              <P><strong>Mã giảm giá tích hợp sẵn:</strong> Mỗi đối tác có mã giảm 10% để chia sẻ hoặc dùng cá nhân — hoa hồng vẫn áp dụng trên đơn đã dùng mã.</P>
              <P><strong>Ghi nhận & theo dõi tự động</strong> qua link affiliate, mã QR và hệ thống xác thực. Không dùng bảng tính, không truy thu hồi tố.</P>
              <P><strong>Thanh toán nhanh & minh bạch:</strong> Hoa hồng hiển thị thời gian thực, rút theo yêu cầu và giải ngân trong 3–5 ngày làm việc.</P>
              <P><strong>Banana Cards lo mọi khâu:</strong> sản xuất, mã hoá, đóng gói, vận chuyển, thu phí gói đăng ký và hỗ trợ khách hàng.</P>
              <P><strong>Kết thúc linh hoạt, không ràng buộc dài hạn.</strong> Bất kỳ bên nào cũng có thể chấm dứt bất cứ lúc nào; hoa hồng đã kiếm được vẫn được thanh toán.</P>
            </>
          ),
        },
        {
          id: "mucdich",
          title: "1. Mục đích",
          body: (
            <>
              <P>Thỏa thuận này ủy quyền cho Đối tác quảng bá các sản phẩm và dịch vụ của Banana Cards trực tuyến thông qua các phương thức giới thiệu đã được phê duyệt và hưởng hoa hồng trên các giao dịch hợp lệ.</P>
              <P>Đối tác hoạt động nghiêm ngặt với tư cách là bên giới thiệu, không phải bên bán lẻ, bán lại, nhà phân phối hay đối tác ký gửi.</P>
            </>
          ),
        },
        {
          id: "quanhe",
          title: "2. Quan hệ hợp tác",
          body: (
            <>
              <P>Đối tác:</P>
              <UL items={[
                "Hoạt động như một bên thầu độc lập",
                "Không có thẩm quyền ràng buộc Banana Cards",
                "Không phải nhân viên, bên nhận quyền, đại lý hay người đại diện",
              ]} />
              <P>Đối tác không hưởng quyền độc quyền hoặc quyền ưu tiên theo địa giới hành chính.</P>
            </>
          ),
        },
        {
          id: "tongquan",
          title: "3. Tổng quan chương trình",
          body: (
            <>
              <P>Đối tác được cung cấp:</P>
              <UL items={[
                "Link theo dõi duy nhất và/hoặc mã QR",
                "Mã giảm giá 10% để chia sẻ hoặc dùng cá nhân",
                "Quyền truy cập bảng quản trị đối tác",
              ]} />
              <P>Mọi việc theo dõi và ghi nhận được quản lý tự động bởi nền tảng.</P>
            </>
          ),
        },
        {
          id: "cocau",
          title: "4. Cơ cấu hoa hồng",
          body: (
            <>
              <P><strong>Doanh thu bán thẻ:</strong> 25% hoa hồng trên phần cứng Banana Cards mua trực tuyến (tính trên giá chưa gồm VAT).</P>
              <P><strong>Doanh thu gói phần mềm:</strong> 25% hoa hồng gia hạn, thanh toán xuyên suốt thời gian khách hàng duy trì gói.</P>
              <P>Đối tác không hưởng biên lợi nhuận bán lẻ và không giữ hoặc bán lại hàng tồn kho.</P>
            </>
          ),
        },
        {
          id: "thaydoi-hoahong",
          title: "4a. Thay đổi tỷ lệ hoa hồng và điều khoản thương mại",
          body: (
            <>
              <P>Banana Cards có quyền cập nhật, sửa đổi, tăng, giảm, thay thế hoặc điều chỉnh tỷ lệ hoa hồng, cấu trúc chiết khấu, quy tắc thanh toán, quy tắc đủ điều kiện hoặc các điều khoản thương mại khác của Chương trình Đối tác theo thời gian.</P>
              <P>Mọi thay đổi như vậy chỉ áp dụng cho khách hàng mới, giới thiệu mới, giao dịch mới, kích hoạt đăng ký mới hoặc doanh số đủ điều kiện mới phát sinh sau ngày có hiệu lực của các điều khoản cập nhật.</P>
              <P>Khách hàng đã được Đối tác giới thiệu hợp lệ trước ngày có hiệu lực của bất kỳ thay đổi nào sẽ tiếp tục chịu sự điều chỉnh của tỷ lệ hoa hồng và điều khoản thương mại đã áp dụng tại thời điểm ghi nhận nguồn ban đầu, với điều kiện:</P>
              <UL items={[
                "ghi nhận nguồn hợp lệ vẫn tồn tại;",
                "khách hàng vẫn hoạt động và thanh toán;",
                "Đối tác vẫn tuân thủ Thỏa thuận này; và",
                "không có gian lận, sử dụng sai, hành vi bị cấm hoặc vi phạm Thỏa thuận này xảy ra.",
              ]} />
              <P>Để tránh nghi ngờ, khách hàng đã giới thiệu hiện có sẽ không tự động chuyển sang tỷ lệ hoa hồng giảm chỉ vì Banana Cards thay đổi điều khoản Chương trình Đối tác đối với khách hàng tương lai.</P>
              <P>Banana Cards sẽ thông báo bằng văn bản về bất kỳ thay đổi quan trọng nào đối với tỷ lệ hoa hồng hoặc điều khoản thương mại. Thông báo sẽ ghi rõ ngày có hiệu lực của các điều khoản mới. Việc tiếp tục tham gia Chương trình Đối tác sau ngày có hiệu lực sẽ cấu thành việc chấp nhận các điều khoản cập nhật đối với các giới thiệu và giao dịch đủ điều kiện trong tương lai.</P>
            </>
          ),
        },
        {
          id: "thoihan",
          title: "5. Thời hạn hưởng hoa hồng",
          body: (
            <>
              <P>Tất cả hoa hồng hợp lệ được trả vĩnh viễn, với điều kiện:</P>
              <UL items={[
                "có ghi nhận nguồn hợp lệ",
                "khách hàng còn hoạt động",
                "Đối tác tuân thủ Thỏa thuận này",
              ]} />
            </>
          ),
        },
        {
          id: "theodoi",
          title: "6. Theo dõi & Ghi nhận nguồn",
          body: (
            <>
              <P>Quyền hưởng hoa hồng phụ thuộc hoàn toàn vào link affiliate, mã QR và hồ sơ ghi nhận từ hệ thống.</P>
              <P>Không chấp nhận yêu cầu thủ công, ảnh chụp màn hình hoặc xác nhận bằng lời nói. Nếu hệ thống không ghi nhận được nguồn, hoa hồng sẽ không được áp dụng.</P>
            </>
          ),
        },
        {
          id: "magiam",
          title: "7. Quy định sử dụng mã giảm giá",
          body: (
            <>
              <P>Mã giảm giá 10% có thể chia sẻ công khai/riêng tư cho khách hàng hoặc dùng cho cá nhân.</P>
              <UL items={[
                "Không làm ảnh hưởng đến mức tính hoa hồng của Đối tác",
                "Không áp dụng đồng thời với các chương trình khuyến mãi khác, trừ khi được phê duyệt",
                "Có thể được điều chỉnh hoặc hủy bỏ tùy theo quyết định của Banana Cards",
              ]} />
            </>
          ),
        },
        {
          id: "quytac",
          title: "8. Quy tắc tính hoa hồng",
          body: (
            <UL items={[
              "Hoa hồng được tính trên giá trị đơn hàng chưa bao gồm VAT",
              "Không phát sinh hoa hồng với các trường hợp: hoàn tiền, bồi hoàn (chargeback), thanh toán lỗi hoặc gói dùng thử miễn phí",
              "Hoa hồng từ gói phần mềm tự động dừng khi khách hàng ngừng thanh toán phí duy trì",
            ]} />
          ),
        },
        {
          id: "thanhtoan",
          title: "9. Điều khoản thanh toán hoa hồng",
          body: (
            <>
              <P>Hoa hồng được theo dõi tự động, hiển thị theo thời gian thực và có thể yêu cầu rút qua bảng quản trị đối tác.</P>
              <P>Tiền sẽ được giải ngân trong vòng 3–5 ngày làm việc kể từ khi có yêu cầu rút tiền hợp lệ. Thanh toán được thực hiện bằng VNĐ hoặc các loại tiền tệ khác được hỗ trợ.</P>
            </>
          ),
        },
        {
          id: "thue",
          title: "9a. Quy định về Thuế",
          body: (
            <>
              <P><strong>Với Đối tác là cá nhân (cư trú tại Việt Nam):</strong> Banana Cards khấu trừ Thuế TNCN theo mức thuế suất quy định hiện hành (10%) trên tổng hoa hồng phát sinh, kê khai và nộp thuế thay mặt Đối tác; số tiền chi trả là thu nhập sau thuế.</P>
              <P><strong>Với Đối tác là doanh nghiệp (pháp nhân Việt Nam):</strong> Đối tác có nghĩa vụ xuất hóa đơn GTGT hợp lệ; VAT (nếu có) được cộng thêm vào tiền hoa hồng; giải ngân sau khi Banana Cards xác nhận tính hợp lệ của hóa đơn.</P>
              <P>Đối tác tự chịu trách nhiệm hoàn toàn về việc tuân thủ nghĩa vụ thuế tại khu vực tài phán nơi mình hoạt động.</P>
            </>
          ),
        },
        {
          id: "trachnhiem",
          title: "10. Trách nhiệm của Đối tác",
          body: (
            <UL items={[
              "Quảng bá trung thực và chính xác về sản phẩm và dịch vụ của Banana Cards",
              "Chỉ sử dụng tài nguyên thương hiệu do Banana Cards cung cấp hoặc cho phép",
              "Công khai mối quan hệ tiếp thị theo đúng quy định pháp luật",
              "Tuân thủ các quy định về quảng cáo, bảo vệ quyền lợi người tiêu dùng và chính sách của các nền tảng đang sử dụng",
            ]} />
          ),
        },
        {
          id: "nghiemcam",
          title: "11. Các hành vi bị nghiêm cấm",
          body: (
            <>
              <P>Đối tác tuyệt đối không được:</P>
              <UL items={[
                "Làm sai lệch tính năng sản phẩm hoặc giá bán niêm yết",
                "Tự ý đưa ra chương trình giảm giá hoặc ưu đãi khi chưa có sự đồng ý",
                "Chạy quảng cáo tìm kiếm (SEM) đấu thầu từ khóa thương hiệu \"Banana Cards\" khi chưa được phê duyệt",
                "Tạo nội dung quảng cáo lừa dối, gây hiểu lầm cho người tiêu dùng",
                "Giới thiệu sản phẩm thẻ NFC cạnh tranh, giả mạo hoặc sao chép",
                "Thao túng hệ thống theo dõi nguồn khách hàng hoặc gian lận dữ liệu hoa hồng",
              ]} />
              <P>Mọi hành vi vi phạm sẽ dẫn đến việc chấm dứt thỏa thuận hợp tác ngay lập tức.</P>
            </>
          ),
        },
        {
          id: "sanhàng",
          title: "11a. Hạn chế bán hàng trên sàn TMĐT",
          body: (
            <>
              <P>Đối tác cam kết không niêm yết, quảng cáo hoặc bán sản phẩm Banana Cards trên bất kỳ sàn thương mại điện tử hoặc nền tảng bên thứ ba nào, bao gồm:</P>
              <UL items={[
                "Shopee, Lazada, TikTok Shop",
                "Amazon, eBay, Alibaba / AliExpress",
                "Facebook Marketplace",
                "Bất kỳ nền tảng thương mại điện tử hoặc thương mại xã hội tương tự",
              ]} />
              <P>Quy định này áp dụng đối với phần cứng vật lý, sản phẩm kỹ thuật số/gói đăng ký, các combo/khuyến mãi/sản phẩm phái sinh, và việc niêm yết dưới tên cá nhân Đối tác, tên công ty hoặc bên thứ ba đại diện.</P>
              <P>Đối tác chỉ được quảng bá qua link tiếp thị chính thức, mã QR của Đối tác và các chiến dịch được phê duyệt dẫn về website/trang thanh toán chính thức của Banana Cards.</P>
              <P><strong>Xử lý:</strong> Vi phạm sẽ dẫn đến đình chỉ ngay lập tức link và mã giảm giá, tước bỏ toàn bộ hoa hồng chưa thanh toán, chấm dứt thỏa thuận không cần báo trước và gửi yêu cầu gỡ bỏ trực tiếp lên sàn TMĐT.</P>
            </>
          ),
        },
        {
          id: "thuonghieu",
          title: "12. Thương hiệu & Tiếp thị",
          body: (
            <>
              <P>Đối tác được phép sử dụng logo đã phê duyệt, hình ảnh sản phẩm chính thức, marketing copy và tài liệu chiến dịch do Banana Cards cung cấp.</P>
              <P>Đối tác không được chỉnh sửa bộ nhận diện thương hiệu, tự đặt tên sản phẩm phái sinh, hoặc mạo danh là nhà phân phối/đại lý ủy quyền chính thức.</P>
            </>
          ),
        },
        {
          id: "baomat",
          title: "13. Cam kết Bảo mật",
          body: (
            <P>Mọi thông tin không công khai — bao gồm cơ cấu hoa hồng, dashboard, khung giá bán lẻ và thuật toán ghi nhận nguồn — đều là thông tin bảo mật và không được tiết lộ cho bất kỳ bên thứ ba nào.</P>
          ),
        },
        {
          id: "chamdut",
          title: "14. Thời hạn & Chấm dứt",
          body: (
            <>
              <P>Thỏa thuận có hiệu lực cho đến khi bị chấm dứt. Bất kỳ bên nào cũng có quyền chấm dứt vào bất kỳ lúc nào thông qua thông báo bằng văn bản.</P>
              <P>Chấm dứt ngay lập tức nếu phát hiện gian lận, mạo danh hoặc hoạt động cạnh tranh không lành mạnh.</P>
              <P><strong>Hệ quả:</strong> Hoa hồng đã phát sinh trước thời điểm chấm dứt vẫn được thanh toán; không phát sinh hoa hồng mới; link và mã giảm giá bị vô hiệu hóa.</P>
            </>
          ),
        },
        {
          id: "trachnhiembt",
          title: "15. Giới hạn trách nhiệm",
          body: (
            <>
              <P>Banana Cards không chịu trách nhiệm đối với thiệt hại gián tiếp/hệ quả, tổn thất về thu nhập kỳ vọng hoặc lỗi ghi nhận nằm ngoài tầm kiểm soát của hệ thống.</P>
              <P>Tổng trách nhiệm bồi thường tối đa không vượt quá số tiền hoa hồng hợp lệ mà Đối tác chưa được thanh toán.</P>
            </>
          ),
        },
        {
          id: "luat",
          title: "16. Luật áp dụng",
          body: (
            <P>Thỏa thuận này được điều chỉnh và giải thích theo quy định pháp luật của nước Cộng hòa Xã hội Chủ nghĩa Việt Nam.</P>
          ),
        },
        {
          id: "toanbo",
          title: "17. Thoả thuận chung",
          body: (
            <>
              <P>Thỏa thuận này cấu thành toàn bộ sự hiểu biết giữa các Bên và thay thế mọi thảo luận hoặc cam kết trước đó liên quan đến Chương trình Đối tác.</P>
              <P>Banana Cards có thể cập nhật điều khoản Chương trình Đối tác theo Mục 4a. Mọi điều khoản cập nhật chỉ áp dụng từ ngày có hiệu lực đã nêu và sẽ không ảnh hưởng đến quyền hoa hồng đã gắn với khách hàng hiện có đã được ghi nhận hợp lệ, trừ khi có thỏa thuận bằng văn bản khác hoặc Đối tác đã vi phạm Thỏa thuận này.</P>
            </>
          ),
        },
      ]}
    />
  );
}